import React from "react";
import Thumbnail from "components/image-stream/thumbnail";
import { MATCH_TYPES } from "../lib/constants";
import { taskTypeToLabelMap } from "shared/taskTypeMap";
import classnames from "classnames";

export const ProductHeader = ({ reference, col, onColumnWidthChange, name, description, openModal, onMatchSelection, ...props }) => {
    const styles = classnames({
        "-reference": reference,
    });
    const {
        upc,
        photographyWipKey,
        shipmentKey,
        shipmentProductKey,
        taskContextKey,
        applicableMatchTypes,
        productActiveTaskTypes,
        isFinalized,
        isContentAccelerateFeatureProduct,
        images,
    } = props.product;
    const isExactMatchVisible = applicableMatchTypes?.some((matchType) => matchType === MATCH_TYPES.exactMatch.label);
    const isPartialMatchVisible = applicableMatchTypes?.some((matchType) => matchType === MATCH_TYPES.partialMatch.label);
    const activeTasks = productActiveTaskTypes && productActiveTaskTypes.map((task) => taskTypeToLabelMap[task]);

    return (
        <div className={`-no-padding justify-between ${reference ? "gray-box" : ""}`}>
            <div className={`dark-inner justify-content-center align-center ${styles} p-10`}>
                <div>
                    <p>{upc}</p>
                    {isContentAccelerateFeatureProduct && <p>Content Accelerate</p>}
                    <p className="description">{description || name}</p>
                    {productActiveTaskTypes && <div className="active-tasks">{activeTasks.join(", ")}</div>}
                    <div className={`button-group justify-content-center ${reference ? "invisible" : ""}`}>
                        <button
                            disabled={!isPartialMatchVisible || !isFinalized}
                            className="button -primary"
                            onClick={() => onMatchSelection(MATCH_TYPES.partialMatch, taskContextKey)}
                        >
                            {MATCH_TYPES.partialMatch.label}
                        </button>
                        <button
                            disabled={!isExactMatchVisible}
                            className="button -primary"
                            onClick={() => onMatchSelection(MATCH_TYPES.exactMatch, taskContextKey, isFinalized)}
                        >
                            {MATCH_TYPES.exactMatch.label}
                        </button>
                    </div>
                </div>
            </div>
            <div className="p-10">
                <Thumbnail
                    photoKey={photographyWipKey}
                    shipmentKey={shipmentKey}
                    shipmentProductKey={shipmentProductKey}
                    size="small"
                    hasEditedShots
                    reference={reference}
                    referenceProductImages={images}
                />
                <div className="m-t-4">
                    <button
                        className={`button -text -full ${reference ? "invisible" : ""}`}
                        onClick={openModal}
                    >
                        Compare All Images
                    </button>
                </div>
            </div>
        </div>
    );
};
